// extracted by mini-css-extract-plugin
module.exports = {"benefits":"benefits_benefits__2C9Aj","bannerImg":"benefits_bannerImg__1RUjl","content":"benefits_content__2t02Z","title":"benefits_title__vlyzA"};